import client from "./client";

const getChargebackDetails = (id) => client.get(`/subsidiary/dashboard/chargeback/details/${id}`);
export default { getChargebackDetails };
